module.exports = __webpack_public_path__ + "static/media/bar-chart.1aa57fde.png";